import { PlaceholderPlugin } from "@platejs/media/react";
import FontAwesome from "../../../utilities/FontAwesome";
import styles from "../../styles/SlateEditor.module.scss";
import { useEditorRef } from "platejs/react";
import classNames from "classnames";
import { compressImage } from "../../../../utils/DataUtilities";
import NotificationManager from "../../../notifications/NotificationManager";

export function ImageUploadButton() {
  const editor = useEditorRef();

  return (
    <div
      className={classNames(
        styles.button,
        styles.buttonWithTooltip,
        styles.imageUploadButton,
      )}
      data-content={"Upload Image"}
    >
      <input
        type="file"
        accept={"image/*"}
        onChange={async (e) => {
          const files = e.target.files;
          if (!files || files.length === 0) return;
          try {
            // Compress to 4MB — @platejs/media's PlaceholderPlugin silently rejects larger images.
            // Default is `uploadConfig.image.maxFileSize: "4MB"` (see node_modules/@platejs/media/dist/react/index.js).
            //   uploadConfig: {
            //   ...
            //       image: {
            //           maxFileCount: 3,
            //               maxFileSize: "4MB",
            //               mediaType: KEYS.img,
            //               minFileCount: 1
            //       },
            //   ...
            //   }
            const compressed = await Promise.all(
              Array.from(files).map((f) => compressImage(f, 4)),
            );
            editor
              .getTransforms(PlaceholderPlugin)
              .insert.media(compressed as unknown as FileList);
          } catch (err) {
            NotificationManager.error(
              err instanceof Error ? err.message : "Image upload failed.",
            );
          }
        }}
        id={"slate-image-input"}
        name={"slate-image-input"}
      />
      <label htmlFor={"slate-image-input"}>
        <FontAwesome fixedWidth prefix={"far"} name={"fa-image"} />
      </label>
    </div>
  );
}
